import { BlockModel } from '../../../../Common/PageBuilder/models/block.model';
import { ChartDisplayElementModel } from '../../../../Common/Reports/models/chart-display-element.model';
import { ReportBlockTypeEnum } from '../../../../Common/Reports/enums/report-block-type.enum';


export function sharedReportDataFromOnePointOhToOnePointOne(block: BlockModel, chartData: any): BlockModel {
    let data;

    switch (block.type.key) {
        case ReportBlockTypeEnum.COVERAGE_OVER_TIME:
            data = (block.displayElement as ChartDisplayElementModel).series[0].dataProvider.getValue();
            const metrics = chartData.metrics;
            data.forEach(dataPoint => {
                metrics.forEach((metric, index) => {
                    dataPoint['key'] = dataPoint['key'] || dataPoint['xValue'];
                    dataPoint['value' + index] = dataPoint['yValue' + index];
                });
            });
            break;
        case ReportBlockTypeEnum.COVERAGE_OVER_TIME_COMPARISON:
            (block.displayElement as ChartDisplayElementModel).series.forEach(s => {
                data = s.dataProvider.getValue();
                data.forEach((dataPoint, index) => {
                    dataPoint['key'] = dataPoint['key'] || dataPoint['xValue'];
                    dataPoint['value'] = dataPoint['value'] || dataPoint['yValue'];
                });
            });
            break;
        case ReportBlockTypeEnum.TOP_10_AUTHORS_BY_VOLUME:
        case ReportBlockTypeEnum.TOP_10_OUTLETS:
        case ReportBlockTypeEnum.TOP_HASHTAGS:
            data = (block.displayElement as ChartDisplayElementModel).series[0].dataProvider.getValue();
            data.forEach(dataPoint => {
                dataPoint['key'] = dataPoint['label'];
                dataPoint['value0'] = dataPoint['value0'] || dataPoint['value'];
            });
            break;
    }

    block['version'] = '1.1';
    return block;
}
